import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAllMedicalFeedbackEmergency } from '../../../store/actions/medicalActions';
import FeedBack from './Feedback';

const mapStateToProps = ({ medicalReducer }) => ({
  results: medicalReducer.results,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllMedicalFeedbackEmergency,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(FeedBack);